export default "__VITE_ASSET__JKCo8rxF__"